export const extractDominantColor = (imageElement: HTMLImageElement): string => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return '#000000';

  // Resize to reduce processing
  const maxSize = 100;
  const scale = Math.min(maxSize / imageElement.width, maxSize / imageElement.height);
  canvas.width = imageElement.width * scale;
  canvas.height = imageElement.height * scale;

  ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  // Color frequency map
  const colorMap: { [key: string]: number } = {};

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const a = data[i + 3];

    // Skip transparent pixels
    if (a < 128) continue;

    // Round to reduce color variations
    const rRounded = Math.round(r / 10) * 10;
    const gRounded = Math.round(g / 10) * 10;
    const bRounded = Math.round(b / 10) * 10;

    const key = `${rRounded},${gRounded},${bRounded}`;
    colorMap[key] = (colorMap[key] || 0) + 1;
  }

  // Find most frequent color
  let maxCount = 0;
  let dominantColor = '0,0,0';
  for (const [color, count] of Object.entries(colorMap)) {
    if (count > maxCount) {
      maxCount = count;
      dominantColor = color;
    }
  }

  const [r, g, b] = dominantColor.split(',').map(Number);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};
